const BOOKING_FEE_PAYMENT_STATUSES = [
  // offline payment statuses
  { text: 'Cancelled', value: 'cancelled' },
  { text: 'Deduction', value: 'deduction' },
  { text: 'Paid (Verified)', value: 'paid' },
  { text: 'Pending', value: 'pending' },
  { text: 'Paid (Pending Verification)', value: 'pending_verification' },

  // online payment statuses
  { text: 'Approved', value: 'approved' },
  { text: 'Pending Registration', value: 'new' },
  { text: 'Paid', value: 'payment_completed' },
  { text: 'Expired', value: 'payment_expired' },
  { text: 'Payment Failed', value: 'payment_failed' },
  { text: 'Payment Submitted', value: 'payment_submitted' },
  { text: 'Payment Initiated', value: 'payment_initiated' },
  { text: 'Rejected', value: 'rejected' },
];
export default BOOKING_FEE_PAYMENT_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/bookingFeePaymentStatuses.js